<template>
  <div>
    <!-- Desktop Navigation -->
    <v-app-bar class="hidden-md-and-up">
      <v-layout wrap justify-center>
        <v-flex xs12 sm12 pl-sm-2>
          <v-layout wrap justify-center>
            <v-toolbar-title>      <!--@click="$router.push('/Dashboard')"-->
              <v-img
                src="../../src/assets/images/teamitelogo.webp"
                height="30px"
                width="100px"
                style="cursor: pointer"
              ></v-img>
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <!-- Hamburger Icon -->
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-menu</v-icon>
                </v-btn>
              </template>

              <!-- Dropdown Menu Content -->
              <v-list>
                <!-- Profile Option -->
                <!-- <v-list-item v-if="$route.path !== '/login'"> 
                <v-list-item-content>
                    <v-list-item-title  @click="$router.push('/login')"
                      >Login</v-list-item-title
                    >
                  </v-list-item-content>
                  </v-list-item> -->
                <v-list-item v-if="$route.path !== '/Renew' && $route.path !== '/Upgrade' && $route.path !== '/subscription' && $route.path !== '/UpgradePaid' && $route.path !== '/teamSubscription' && $route.path !== '/teamSubscriptionRenew' && $route.path !== '/signup' && $route.path !== '/terms-and-conditions' && $route.path !== '/refund-policy'">
                  <v-list-item-content>
                    <v-list-item-title @click="Register()"
                      >Register</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>

                <!-- Logout Option -->
                <v-list-item @click="logoutCheck()"  v-if="$route.path !== '/signup' && $route.path !== '/login'">
                  <!-- <v-list-item-icon>
          <v-icon>mdi-logout</v-icon>
        </v-list-item-icon> -->
                  <v-list-item-title>Logout</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-app-bar>

    <v-layout
      wrap
      justify-center
      class="hidden-sm-and-down"
      style="height: 80px"
    >
      <v-flex md12 lg12 class="fixItem">
        <v-layout wrap justify-center fill-height>
          <v-flex md11 xs12 lg11 align-self-center>
            <v-card color="transparent" elevation="0">
              <v-layout wrap justify-center>
                <v-flex md8 lg10>
                  <v-layout wrap justify-start>
                    <v-flex md8 lg6 pa-0>
                      <v-layout wrap justify-start>
                        <v-flex
                          
                          xs8
                          lg7
                          align-self-center
                          @click="redirectTo()"
                        >    <!--@click="$router.push('/Dashboard')"-->
                          <v-img
                            class="responsive-img"
                            style="cursor: pointer"
                            src="../../src/assets/images/teamitelogo.webp"
                          ></v-img>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <!-- <v-flex lg1 align-self-center>
                  <v-icon>mdi-bell</v-icon>
                </v-flex> -->

                <v-flex md2 lg1 class="text-end" align-self-center v-if="hasToken">
                  <v-btn
                    style="background-color: #00a08e"
                    @click="Register()"
                    v-if="$route.path !== '/Renew' && $route.path !== '/Upgrade' && $route.path !== '/subscription' && $route.path !== '/UpgradePaid' && $route.path !== '/teamSubscription' && $route.path !== '/teamSubscriptionRenew' && $route.path !== '/signup'"
                  >
                    <span
                      style="
                        font-family: Montserrat-Regular;
                        font-size: 15px;
                        font-weight: 600;
                        color: white;
                        text-transform: none;
                      "
                    >
                      Register
                    </span>
                  </v-btn>
                </v-flex>

                <v-flex
                  md2
                  lg1
                  class="text-end"
                  align-self-center
                  v-if="isVisibleOnCurrentPage()"
                >
                  <v-btn @click="logoutCheck()" plain class="px-0">
                    <span
                      style="
                        font-family: Lato-Regular;
                        font-size: 15px;
                        font-weight: 600;
                        text-transform: none;
                      "
                    >
                      Logout &nbsp;
                    </span>
                    <v-icon>mdi-logout</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-dialog width="400px" v-model="logoutDialog">
      <v-card>
        <v-layout wrap justify-center>
          <v-flex lg12 pa-4>
            <v-layout wrap justify-center>
              <v-flex lg12 class="text-center">
                <span>Are you sure you want to Log Out?</span>
              </v-flex>
              <v-flex lg12 class="text-center" pt-4>
                <v-layout wrap justify-center>
                  <v-flex lg6>
                    <v-btn @click="logoutDialog = false">
                      <span style="color: #00a08e">Cancel</span>
                    </v-btn>
                  </v-flex>
                  <v-flex lg6>
                    <v-btn style="background-color: #00a08e" @click="Logout()">
                      <span style="color: white">Yes</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      profile: "",
      msg: "",
      showSnackBar: false,
      ServerError: false,
      logoutDialog: false,
    };
  },
  computed: {
    appUser() {
      try {
        const userData = this.$store.state.userData;
        if (typeof userData === "string") {
          return JSON.parse(userData);
        } else {
          return userData; // Assuming it's already an object
        }
      } catch (e) {
        console.error("Failed to parse userData:", e);
        return {};
      }
    },
    hasToken() {
      return !localStorage.getItem('token');
    },
  },
  mounted() {
    // this.getProfileHeader();
  },
  methods: {
    Register() {
      if (this.$route.path !== "/signup") {
        this.$router.push("/signup");
      }
    },

    redirectTo() {
    if (!localStorage.getItem('token')) {
      this.$router.push('/');
    }
    else {
      this.$router.push('/Dashboard');
    }
  },

    isVisibleOnCurrentPage() {
      const currentPath = this.$route.path;
      return (
        currentPath === "/subscription" ||
        currentPath === "/teamSubscription" ||
        currentPath === "/Upgrade" ||
        currentPath === "/Renew" ||
        currentPath === "/teamSubscriptionRenew" ||
        currentPath === "/payment" ||
        currentPath === "/paymentRenew" ||
        currentPath === "/paymentUpgrade" ||
        currentPath === "/paymentBulk"
      );
    },
    logoutCheck() {
      this.logoutDialog = true;
    },
    Logout() {
      this.logoutDialog = false;
      this.$store.commit("logoutUser", true);
    },

    profilePage() {
      if (this.$route.path !== "/profile") {
        this.$router.push("/profile");
      }
    },

    Logout() {
      this.logoutDialog = false;
      this.$store.commit("logoutUser", true);
    },
  },
};
</script>

<style>
.v-main {
  display: flex;
  flex: 1 0 auto;
  max-width: 100%;
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 0 !important; /* Override padding */
}
</style>

<style>
.v-main {
  display: flex;
  flex: 1 0 auto;
  max-width: 100%;
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Add padding only for medium and smaller screens */
@media (max-width: 960px) {
  .v-main {
    padding: 64px 0px 0px !important;
  }
}
</style>

<style scoped>
.responsive-img {
  height: 30px;
}

@media (min-width: 600px) {
  .responsive-img {
    height: 40px;
  }
}

@media (min-width: 960px) {
  .responsive-img {
    height: 40px;
    width: 150px;
  }
}

@media (min-width: 1920px) {
  .responsive-img {
    height: 80px; /* Adjust the height for extra-large screens */
    width: 250px; /* Adjust the width for extra-large screens */
  }
}
</style>